import React from "react";
import { MODULES, MODULE_CATEGORIES, IMAGES } from "../data/content";
import ProductImage from "./ProductImage";
import "../styles/modules.css";

/**
 * Full module grid, grouped by category. Pass `limit` to show only the
 * first N modules (used for a teaser on the Home page); pass `grouped`
 * to render category headings (used on the full Product > Modules page).
 */
function ModulesGrid({ limit, grouped = false }) {
  if (!grouped) {
    const list = limit ? MODULES.slice(0, limit) : MODULES;
    return (
      <div className="modules-grid">
        {list.map((mod) => (
          <div key={mod.id} className={`modules-card ${mod.featured ? "modules-card--featured" : ""}`}>
            <h3 className="modules-card-name">{mod.name}</h3>
            <p className="modules-card-detail">{mod.detail}</p>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="modules-groups">
      {MODULE_CATEGORIES.map((cat) => {
        const items = MODULES.filter((m) => m.category === cat.id);
        if (!items.length) return null;
        return (
          <div className="modules-group" key={cat.id}>
            <h3 className="modules-group-title">{cat.label}</h3>
            <div className="modules-grid">
              {items.map((mod) => (
                <div key={mod.id} className={`modules-card ${mod.featured ? "modules-card--featured" : ""}`}>
                  {mod.image && IMAGES[mod.image] && (
                    <ProductImage
                      src={IMAGES[mod.image]}
                      alt={`${mod.name} — Admin Dashboard`}
                      frame="card"
                      className="modules-card-image"
                    />
                  )}
                  <h3 className="modules-card-name">{mod.name}</h3>
                  <p className="modules-card-detail">{mod.detail}</p>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ModulesGrid;
